import { Card } from "~/components/ui/card";
import { Skeleton } from "~/components/ui/skeleton";

function TitleSkeleton({ width }: { width: string }): React.JSX.Element {
  return (
    <div className="flex items-center gap-2">
      <Skeleton className="size-8 rounded-xl" />
      <Skeleton className={`h-5 ${width}`} />
    </div>
  );
}

function ActionRowSkeleton(): React.JSX.Element {
  return (
    <div className="flex items-baseline gap-2">
      <Skeleton className="h-10 flex-1 rounded-lg" />
      <Skeleton className="h-8 w-16 rounded-lg" />
    </div>
  );
}

export const ProfileSettingsSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      {/* Personal details & Profile details */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Card>
          <TitleSkeleton width="w-32" />
          <div className="flex items-center gap-4">
            <Skeleton className="h-20 w-20 rounded-full" />
            <div className="flex flex-col gap-2">
              <Skeleton className="h-8 w-28 rounded-lg" />
              <Skeleton className="h-8 w-20 rounded-lg" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-10 w-full rounded-lg" />
            </div>
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-10 w-full rounded-lg" />
            </div>
          </div>
        </Card>

        <Card>
          <TitleSkeleton width="w-28" />
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-10 w-full rounded-lg" />
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-24 w-full rounded-lg" />
          </div>
        </Card>
      </div>

      {/* Email & phone */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Card>
          <TitleSkeleton width="w-28" />
          <ActionRowSkeleton />
        </Card>
        <Card>
          <TitleSkeleton width="w-28" />
          <ActionRowSkeleton />
        </Card>
      </div>

      {/* Account deactivation */}
      <Card className="flex-row items-center justify-between">
        <div className="flex flex-col gap-1">
          <Skeleton className="h-5 w-36" />
          <Skeleton className="h-4 w-64" />
        </div>
        <Skeleton className="h-8 w-32 rounded-lg" />
      </Card>

      {/* Save button */}
      <div className="flex justify-end">
        <Skeleton className="h-10 w-28 rounded-lg" />
      </div>
    </div>
  );
};
